import { useEffect, useRef } from "react";
import {
  enqueueFirstWinsChatTrigger,
  scheduleTrackedChatTriggerDelay,
} from "@/hooks/chat/helpers/chatTriggerCoordinator";

export const useProductCardIdleTrigger = ({
  enabled,
  timeout,
  popModal,
  triggerChat,
  triggerKey,
  sessionEpoch = 0,
}) => {
  const hasEngaged = useRef(false);
  const hasTriggered = useRef(false);
  const cancelCountdownRef = useRef(null);

  useEffect(() => {
    hasEngaged.current = false;
    hasTriggered.current = false;
  }, [sessionEpoch]);

  useEffect(() => {
    if (!enabled) return;

    const activityEvents = ["mousemove", "keydown", "scroll", "click"];

    const resetIdleTimer = () => {
      if (!hasEngaged.current || hasTriggered.current) return;
      if (cancelCountdownRef.current) cancelCountdownRef.current();
      cancelCountdownRef.current = scheduleTrackedChatTriggerDelay(
        triggerKey,
        "Product Card Idle",
        timeout,
        () => {
          if (hasTriggered.current) return;
          enqueueFirstWinsChatTrigger(() => {
            if (hasTriggered.current) return;
            const ran = triggerChat("Product Card Idle", {
              popModal,
              triggerKey,
            });
            if (ran !== false) {
              hasTriggered.current = true;
            }
          });
        },
      );
    };

    const handleEngaged = () => {
      if (hasEngaged.current) return;
      hasEngaged.current = true;
      activityEvents.forEach((e) =>
        document.addEventListener(e, resetIdleTimer),
      );
      resetIdleTimer();
    };

    document.addEventListener("product-cards-engaged", handleEngaged);

    return () => {
      document.removeEventListener("product-cards-engaged", handleEngaged);
      activityEvents.forEach((e) =>
        document.removeEventListener(e, resetIdleTimer),
      );
      if (cancelCountdownRef.current) cancelCountdownRef.current();
    };
  }, [enabled, timeout, popModal, triggerChat, triggerKey, sessionEpoch]);
};
